function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Livello 1",
    id: "Livello_1",
    viewBox: "0 0 151.57 151.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 1038.5,
    cy: 467.01,
    r: 72.28,
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    transform: "translate(-988.78 479.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    x1: 47.57,
    x2: 103.99,
    y1: 103.99,
    y2: 47.57
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#da2244",
      stroke: "#f2f2f2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    x1: 45.8,
    x2: 105.7,
    y1: 45.87,
    y2: 105.77
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedx);
export default __webpack_public_path__ + "static/media/redx.4cc5dee96ff4ef5ad6b63b95e3ea9861.svg";
export { ForwardRef as ReactComponent };